
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanProjectHandlers/LeanProjectHandlers.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanProjectHandlers.html');
        
        var script = require('./LeanProjectHandlers.ts').default;
        module.exports = require('./LeanProjectHandlers.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    